export default [
    "Bermuda - BER - Hamilton - St. Mark",
    "Australia - VIC - Melbourne - St. Anthony & Archangel Micheal",
    "Australia - VIC - Melbourne - St. George",
    "Australia - VIC - Melbourne - St. Mark",
    "London - St. Mary & Pope Kyrollos VI",
    "Other"
];